@if (!hasValues() || !chartOptions?.series || chartOptions.series.length === 0) {
  <div class="h-[80%] flex items-center justify-center text-gray-400">
    <div class="text-center">
      <span class="block">
        <mat-icon class="material-icons-outlined !text-[100px] !w-auto !h-auto">
          crisis_alert
        </mat-icon>
      </span>
      <span class="block">
        {{ 'No data available' | translate }}
      </span>
    </div>
  </div>
} @else {
  @if (['bar', 'line', 'area'].includes(type)) {
    @if (chartOptions) {
      <div class="flex w-full">
        <apx-chart
          class="!flex-grow"
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [stroke]="chartOptions.stroke!"
          [dataLabels]="chartOptions.dataLabels!"
          [plotOptions]="chartOptions.plotOptions!"
          [xaxis]="chartOptions.xaxis!"
          [colors]="chartOptions.colors!"
          [fill]="chartOptions.fill!"
          [yaxis]="chartOptions.yaxis!"
          [legend]="chartOptions.legend!"
        ></apx-chart>
      </div>
    }
  } @else {
    <div class="text-red-500 text-center p-4">
      Invalid chart type: {{ type }}
    </div>
  }
}